import { render, staticRenderFns } from "./Storecomment.vue?vue&type=template&id=3d28a248&scoped=true&"
import script from "./Storecomment.vue?vue&type=script&lang=js&"
export * from "./Storecomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d28a248",
  null
  
)

export default component.exports